import styled from "styled-components";
import { Row, Col } from "../App.styles";
import ImageThumbnail from "../common/ImageThumbnail";

const HeaderCol = styled(Col)`
  width: 50%;
  flex-direction: column;

  img {
    max-width: 100%;
  }

  @media (max-width: ${({ theme }) => theme.maxMobileWidth}) {
    width: 40%;
  }
`;

const MyTeam = ({ myTeam }) => {
  if (!myTeam) {
    return null;
  }

  const { assets, name, points, points_place, completed } = myTeam;
  // Thumbnails are served with ImageThumbnail component that will 
  // auto populate thumbnail URLs
  const photo = assets?.photos?.find((photo) => photo.name === "standard");

  if (!name) {
    return null;
  }

  return (
    <Row>
      {photo ? <HeaderCol><ImageThumbnail src={photo.url} alt={name} /></HeaderCol> : null}
      <HeaderCol className="col--stretch">
        <strong>{name}</strong>
        <span>Rank: {points_place}</span>
        <span>Points: {points}</span>
        <span>Completed: {completed}</span>
      </HeaderCol>
    </Row>
  );
};

export default MyTeam;
